import React from 'react'
import BookCourtComp from '../components/BookCourt/BookCourtComp'

const BookCourt = () => {
  return (
    <>
        <BookCourtComp/> 
      
            </>
  )
}

export default BookCourt